/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var in_process_file = false;
var count_file = 0;
var count_index = 0;

 var bar = null;

function csvToJson(csv){
  var lines=csv.split("\n");
  var result = [];
  var headers=lines[0].split(",");

  for(var i=1;i<lines.length;i++){
      var obj = {};
      var currentline=lines[i].split(",");

      for(var j=0;j<headers.length;j++){
          obj[headers[j]] = currentline[j];
      }
      result.push(obj);
  }
  return JSON.stringify(result); 
}

async function getVariantId(sku) {
  var variant_id = await $.get('/search?view=sku&type=product&q=variants.sku:' + sku, function(responseData) {
    return responseData.replace(/\n/g, '').replace(/\r/g, '').replace(/"/g, '');
  })
  console.log(variant_id);
  if (variant_id.length < 3) {
    var variant_id = await $.get('/search?view=sku&type=product&q=' + sku, function(responseData) {
      return responseData.replace(/\n/g, '').replace(/\r/g, '').replace(/"/g, '');
    })
  }
  console.log(variant_id);
  return variant_id;
}

function updateTotalOrder() {
  if ($("[data-cart-total]").html() != undefined) {

    var total = parseFloat($("[data-cart-total]").html().replace("€", "").replace(".", "").replace(",", ".").replace("\n", "").replace(" ", ""));

    fetch(window.theme.localeRootUrl + "/cart/update.js", {
      credentials: "same-origin",
      method: "POST",
      body: JSON.stringify({
        attributes: {
          total_order: total
        }
      }),
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function(n) {
    });


    var missing_total = parseFloat(70.00) - parseFloat(total);

    if (missing_total > 0.00) {
      $(".page__description").html("Encore " + String(missing_total.toFixed(2)) + " € pour bénéficier des frais de port gratuits !");
    } else {
      $(".page__description").html("Vous bénéficiez des frais de port gratuits !");
    }
  } else {
    fetch(window.theme.localeRootUrl + "/cart/update.js", {
      credentials: "same-origin",
      method: "POST",
      body: JSON.stringify({
        attributes: {
          total_order: "0"
        }
      }),
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function(n) {
    });
    $(".empty-state__description").html("Encore 70 € pour bénéficier des frais de port gratuits !");
  }
}

function progressBarAutomation() {
  if (in_process_file && count_index == count_file - 1) {
    count_file = 0;
    count_index = 0;
    in_process_file = false;
    bar.animate(1);
    $("[data-percentage]").html("100%");
    setTimeout(function() {
      updateTotalOrder()
    }, 1000);
    setTimeout(function() {
      window.location.reload();
    }, 3000);
  } else if (in_process_file) {
    var k = 1 / count_file * count_index;
    bar.animate(k);
    count_index++;
    var percentage = k * 100;
    $("[data-percentage]").html(Math.round(percentage) + "%");
  } 
}

function process_file() {
  var inputs = document.querySelectorAll( '#file' );
  Array.prototype.forEach.call( inputs, function( input )
                               {
    var label	 = input.nextElementSibling,
        labelVal = label.innerHTML;

    input.addEventListener( 'change', function( e )
                           {
      var fileName = '';
      if( this.files && this.files.length > 1 )
        fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
      else
        fileName = e.target.value.split( '\\' ).pop();
      if ( fileName )
        $('[for="file"] span').html(fileName)
        else
          $('[for="file"] span').html(labelVal)

          var reader = new FileReader();
      reader.onload = async function () {
        in_process_file = true;
        $(".automation-cart, .automation-cart-bg").fadeIn();
        bar = new ProgressBar.Line('.automation-cart__loading', {
          strokeWidth: 1,
          easing: 'easeInOut',
          duration: 600,
          color: '#19438d',
          trailColor: '#eee',
          trailWidth: 1,
          svgStyle: {width: '100%', height: '100%'}
        });

        console.log(reader.result);
        var lines = reader.result.replace(/\n/g, '$').replace(/\r/g, '').split('$').filter(function(e){return e});
        console.log(lines);
        var y = 0;

        var sep = ";";
        if (lines[0].indexOf(";") > -1) {
          sep = ";";
        } else if (lines[0].indexOf(",") > -1) {
          sep = ",";
        }

        count_file = lines.length;
        for (var i = 0;i < lines.length;i++) {
          var sku = lines[i].split(sep)[0]
          var multiplier = 1;
         
          console.log(lines[i]);
          var li = lines[i].replace(/"/g, '').replace(/%22/g, '');
          if (li.split(sep).length < 2 || sku == "%22" || sku == '"') {
            $(".automation-cart__container .error").append("<p>Le fichier contient une erreur à la ligne " + i + ".</p>");
           progressBarAutomation();
          } else {
  
            var quantity = parseInt(lines[i].split(sep)[1].split("#")[0]);

            var variant_id = await getVariantId( sku.toUpperCase());

            var variant_id = variant_id.split("#");
            if (variant_id.length > 1) {
              multiplier = variant_id[1];
              variant_id = variant_id[0];
            } else {
              variant_id = variant_id[0]; 
            }

            console.log(quantity % multiplier == 0);

            if (quantity % multiplier == 0) {
              CartJS.addItem(parseInt(variant_id), quantity, {}, {
                "success": function(data, textStatus, jqXHR) {
                  console.log(in_process_file, count_index, count_file);
                  progressBarAutomation();
                },
                "error": function(data, textStatus, jqXHR) {
                 progressBarAutomation();
                  $(".error").html("Impossible d'ajouter cette référence au panier"); 

                  $(".automation-cart__container .error").append("<p>" + sku + " - Impossible d'ajouter cette référence au panier</p>");
                }
              });
            } else {
              progressBarAutomation();
              $(".automation-cart__container .error").append("<p>Erreur du SKU '" + sku + "' : Multiple de quantité incorrect</p>");
            }
          }
        }

      };
      reader.readAsBinaryString(this.files[0]);
    });
  });
}

$(document).ready(function() {
  if (window.location.href.indexOf("/cart") > -1) {
   updateTotalOrder(); 
  }
  var button = document.querySelector(".btn-checkout");
  if (button != null) {
    button.addEventListener("click",function(e){
      e.preventDefault();
      if (window.location.href.indexOf("/cart") > -1) {
        var total = parseFloat(document.querySelector(".cart-recap__price-line .money.pre-money").innerHTML.replace(".", "").replace("€", "").replace(",", "."));
        if (total >= 70.00) {
          document.querySelector('.checkout[name="checkout"]').click();
        } else {
          $(".mini-cmd").fadeIn(); 
        }
      } else {
        var total = parseFloat(document.querySelector(".mini-cart__recap .money.pre-money").innerHTML.replace(".", "").replace("€", "").replace(",", "."));
        if (total >= 70.00) {
          document.querySelector('.checkout[name="checkout"]').click();
        } else {
          $(".mini-cmd").fadeIn(); 
        }
      }
    },false);
  }

  process_file();


  $(".automation-add-to-cart__submit").on('click', async function() {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    $(".automation-add-to-cart__form .error").html(""); 
    
    var sku = $("#productcode").val();
    var quantity = parseInt($("#productQuantity").val());

    if (quantity <= 0) {
      $(".automation-add-to-cart__form .error").html("La quantité doit être supérieur à 0"); 
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    } else {
      if (sku && sku.length > 3) {
        var variant_id = await getVariantId( sku.toUpperCase());
        var has_multiplier = variant_id.split("#").length > 1 ? true : false;
        console.log(has_multiplier);
        var multiplier = 1;
        if (has_multiplier) {
          var multiplier = parseInt(variant_id.split("#")[1]);
          var variant_id = parseInt(variant_id.split("#")[0]);
        }

        if (quantity % multiplier == 0) {
          CartJS.addItem(parseInt(variant_id), quantity, {}, {
            "success": function(data, textStatus, jqXHR) {
              document.dispatchEvent(new CustomEvent("theme:loading:end"));
              document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: variant_id,
                  quantity: quantity
                }
              }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
           
            },
            "error": function(data, textStatus, jqXHR) {
              $(".automation-add-to-cart__form .error").html("Impossible d'ajouter cette référence au panier"); 
              document.dispatchEvent(new CustomEvent("theme:loading:end"));
            }
          });
        } else {
          $(".automation-add-to-cart__form .error").html("La quantité doit être un multiple de " + multiplier); 
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
        }

      } else {
        $(".automation-add-to-cart__form .error").html("Impossible d'ajouter cette référence au panier"); 
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
      }
    }

  });

});
